import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {ControlContainer, FormControl, NgForm, NgModel} from '@angular/forms';
import {BdLabeledDateInputComponent} from '@brother-apps/brother-dealerapp-shared-lib';
import {Subscription} from 'rxjs';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {ProjectsConst} from '../../../consts/projects-consts';
import {ContactModel} from '../../../models/brother-contacts.model';
import {ProjectDistributorStatusEnum} from '../../../enums/project-distributor-status.enum';
import {RequestedProductInfoModel} from '../../../models/requested-product-info.model';

@Component({
    selector: 'app-additional-items-extension-editor',
    templateUrl: './additional-items-extension-editor.component.html',
    styleUrls: ['./additional-items-extension-editor.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class AdditionalItemsExtensionEditorComponent extends EditModalSectionBaseComponent implements OnInit, OnDestroy {

    public productDistributorChoices: { label: string, labelClass: string, itemClass?: string, id?: number }[];
    public productDistributorValues: number[];
    public addHardware = true;
    @Input() public forceFormValidationVisibility: boolean;

    @ViewChild('rolloutStartNgModel', {static: true}) rolloutStartNgModel: NgModel;
    @ViewChild('productDistributorNgModel', {static: true}) productDistributorNgModel: NgModel;
    @ViewChildren(BdLabeledDateInputComponent) bdLabeledDateInputs: BdLabeledDateInputComponent[];
    private closeEditDialogModalsSub: Subscription;
    private quoteClosingDateChangedSub: Subscription;

    constructor(
        public editModalService: EditModalService,
        private modalVisibilityService: ModalVisibilityService
    ) {
        super(editModalService);
    }


    public ngOnInit() {
        super.ngOnInit();
        this.closeEditDialogModalsSub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(sourceId => {
            if (sourceId !== 'edit-modal_clicked') {
                this.bdLabeledDateInputs.forEach(component =>
                    component.hideDatePicker()
                );
            }
        });

        this.quoteClosingDateChangedSub = this.editModalService.quoteClosingDateChangedAnnounced$.subscribe(_ => {
            if (this.rolloutStartNgModel) {
                this.rolloutStartNgModel.control.updateValueAndValidity();
            }
        });
        if (this.model.project.requestedProductInfo !== null && this.model.project.requestedProductInfo.isOneshot) {
            this.model.project.requestedProductInfo.rolloutEnd = null;
        }
    }


    private filterOutMpsBrotherSupplyDistributorName(contacts): ContactModel[] {
        return contacts && contacts.filter(k => k.name !== ProjectsConst.MPS_BROTHER_SUPPLY_DISTRIBUTOR_NAME);
    }


    public getProductDistributorChoices(): { label: string, labelClass: string, itemClass?: string, id?: number }[] {
        if (!this.productDistributorChoices && this.model?.filteredProductDistributors) {
            this.productDistributorChoices = this.model.filteredProductDistributors.map(distributor =>
                ({
                    label: distributor.name + this.getDistributorStatusHtml(distributor.status),
                    labelClass: ProjectDistributorStatusEnum[distributor.status] === ProjectDistributorStatusEnum.INACTIVE ? 'inactive' : '',
                    itemClass: ProjectDistributorStatusEnum[distributor.status] === ProjectDistributorStatusEnum.INACTIVE ? 'hidden' : '',
                    id: distributor.id
                })
            );
        }
        return this.productDistributorChoices;
    }

    public getSecondaryProductDistributorChoices(): { label: string, labelClass: string, itemClass?: string, id?: number }[] {
        let result = this.getProductDistributorChoices();
        // add empty value that allows to reset the value to null
        result = [{label: 'Keine Auswahl', labelClass: ''}, ...result];
        // find the first choice that has the same id as the selected productDistributorId
        // and set class to hidden if is not already there
        // and also replace the choice in result variable with its copy to avoid changing the original object
        const selectedProductDistributorId = this.model.project.requestedProductInfo.productDistributorId;
        if (selectedProductDistributorId) {
            const choiceIndex = result.findIndex(choice => choice.id === selectedProductDistributorId);
            if (choiceIndex !== -1) {
                // Create a copy of the choice object
                const choiceToHide = {...result[choiceIndex]};
                choiceToHide.labelClass = 'hidden';
                choiceToHide.itemClass = 'hidden';
                // Replace the original choice object with the modified copy
                result[choiceIndex] = choiceToHide;
            }
        }
        return result;
    }

    private getDistributorStatusHtml(status: string): string {
        if (ProjectDistributorStatusEnum[status] === ProjectDistributorStatusEnum.INACTIVE) {
            return ' <b>(inaktiv)</b>';
        }
        return '';
    }

    public getProductDistributorValues(): number[] {
        this.model.productDistributors = this.filterOutMpsBrotherSupplyDistributorName(this.model && this.model.productDistributors);

        if (this.model.filteredProductDistributors.length === 0) {
            this.model.filteredProductDistributors = [...this.model.productDistributors];
            if (!this.model.project.id) {


                this.model.filteredProductDistributors = this.model.filteredProductDistributors.filter(distributor => ProjectDistributorStatusEnum[distributor.status] !== ProjectDistributorStatusEnum.INACTIVE);
                console.log('getProductDistributorValues refiltered');
            }

            // reinit productDistributorChoices
            this.productDistributorChoices = null;
            this.getProductDistributorChoices();
        }

        this.productDistributorValues = this.model.filteredProductDistributors.map(distributor => distributor.id);
        return this.productDistributorValues;
    }

    public getSecondaryProductDistributorValues(): number[] {
        let result = this.getProductDistributorValues();
        // add empty value that allows to reset the value to null
        result = [null, ...result];
        return result;
    }

    public test(rolloutEndNgModel: any) {
        console.log('rolloutEndNgModel test ', rolloutEndNgModel);
        console.log('rolloutEndNgModel errors', rolloutEndNgModel.errors);

    }

    public onRolloutStartChanged(rolloutEndNgModel: NgModel) {
        setTimeout(_ => {
            rolloutEndNgModel.control.updateValueAndValidity();
            // console.log('this.rolloutEndNgModel.control', this.rolloutEndNgModel.control);
        }, 0);

    }

    public setRollOutEnd() {
        // if (this.model.project.requestedProductInfo.isOneshot)
        // {
        //     this.model.project.requestedProductInfo.rolloutEnd = null;
        // }

    }

    public getRolloutStartMinDay() {
        return this.editModalService.getRolloutStartMinDay();
    }

    public getRolloutEndMinDate(rolloutStart: Date): Date {
        return this.editModalService.getRolloutEndMinDate(rolloutStart);
    }

    public ngOnDestroy(): void {
        if (this.closeEditDialogModalsSub) {
            this.closeEditDialogModalsSub.unsubscribe();
        }

        if (this.quoteClosingDateChangedSub) {
            this.quoteClosingDateChangedSub.unsubscribe();
        }
    }

    // returns list of product distributor ids that are inactive
    getInactiveProductDistributorIdsList(): number[] {
        return this.model.productDistributors.filter(distributor =>
            ProjectDistributorStatusEnum[distributor.status] === ProjectDistributorStatusEnum.INACTIVE)
            ?.map(distributor => distributor.id);
    }


    onSecondaryProductDistributorChanged(requestedProductInfo: RequestedProductInfoModel, ngModel: NgModel) {
        // There is a difference between null and undefined, 'Optional auswählen' === undefined and 'Keine Auswahl' === null
        // So after 'Keine Auswahl' is selected, we need to set it to undefined value,  to display 'Optional auswählen' instead selected value 'Keine Auswahl'
        if (!requestedProductInfo.secondaryProductDistributorId) {
            requestedProductInfo.secondaryProductDistributorId = -1; // without this line, the input value is not sometimes changed back to 'Optional auswählen'
            ngModel?.control.updateValueAndValidity();
            setTimeout(() => {
                requestedProductInfo.secondaryProductDistributorId = undefined;
                ngModel?.control.updateValueAndValidity();
            }, 0);
        }

    }

    onProductDistributorChanged(requestedProductInfo: RequestedProductInfoModel) {
        if (requestedProductInfo.productDistributorId === requestedProductInfo.secondaryProductDistributorId) {
            requestedProductInfo.secondaryProductDistributorId = undefined;
        }
    }
}
